// 产品详情
<template>
  <div class="proDetail">
    <!-- pc -->
    <div class="detail" v-if="nowNew.newsCode && !isMobile">
      <div class="top">
        <img
          v-if="nowNew.newsImageUrl.indexOf(',') == -1"
          :src="URL + nowNew.newsImageUrl"
          alt=""
        />
        <el-carousel v-else :interval="5000" indicator-position="outside">
          <el-carousel-item
            v-for="item in nowNew.newsImageUrl.split(',')"
            :key="item"
          >
            <img :src="URL + item" alt="" />
          </el-carousel-item>
        </el-carousel>
        <div class="intro-box">
          <div class="intro-title">{{ nowNew.title }}</div>
          <div class="intro-desc">
            <div class="sub">产品简介:</div>
            <div class="text">{{ nowNew.description || "暂无" }}</div>
          </div>
        </div>

        <!-- 左右切换按钮 -->
        <button class="pre" @click="changeNew('pre')" v-show="preNew.id">
          &lsaquo;
        </button>
        <button class="next" @click="changeNew('next')" v-show="nextNew.id">
          &rsaquo;
        </button>
      </div>
      <div class="bottom">
        <div class="content">
          <p>产品详情</p>
          <div class="con-desc" v-html="nowNew.contentStr"></div>
          <p>产品推荐</p>
          <div class="recommed">
            <div
              class="re-item"
              v-for="item in recommendList"
              :key="item.id"
              @click="getDetail(item)"
            >
              <img :src="URL + imageLen(item.newsImageUrl)" :alt="item.title" />
              <div class="desc">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div class="detail" v-else-if="nowNew.newsCode && isMobile == 1">
      <div class="m-title">{{ nowNew.title }}</div>
      <div class="m-img-box">
        <img
          v-if="nowNew.newsImageUrl.indexOf(',') == -1"
          class="just"
          :src="URL + nowNew.newsImageUrl"
          alt=""
        />
        <van-swipe v-else indicator-color="white">
          <van-swipe-item
            v-for="item in nowNew.newsImageUrl.split(',')"
            :key="item.id"
          >
            <img :src="URL + item" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="content">
        <p>产品简介</p>
        <div class="con-desc">{{ nowNew.description || "暂无" }}</div>
        <p>产品详情</p>
        <div class="con-desc" v-html="nowNew.contentStr"></div>
      </div>
      <div class="other">
        <div
          class="pre"
          :style="{ visibility: preNew.id ? 'visible' : 'hidden' }"
          @click="changeNew('pre')"
        >
          <span class="symbol">&larr;</span> 上一个
        </div>
        <div
          class="next"
          :style="{ visibility: nextNew.id ? 'visible' : 'hidden' }"
          @click="changeNew('next')"
        >
          下一个 <span class="symbol">&rarr;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "../../util/config";
import {
  searchNewsinfo,
  sysNewsList,
  getRecentNews,
} from "../../util/news/news";
import qs from "qs";

export default {
  data() {
    return {
      URL,
      nowNew: {},
      isMobile: sessionStorage.getItem("isMobile"),
      recommendList: [],
      preNew: {},
      nextNew: {},
      params: {
        pageIndex: 1,
        pageSize: 12,
        newsCode: "25d8062b40214b4d86d6809fc31fa6fb",
      },
    };
  },
  created() {
    this.params.newsCode = this.$route.query.code;
    searchNewsinfo(this.$route.query.id).then((res) => {
      this.nowNew = res.data;

      this.getRecent();
    });
    this.getReList();
  },
  computed: {
    imageLen() {
      return (url) => {
        return url.split(",")[0];
      };
    },
  },
  mounted() {},
  methods: {
    // 获取推荐产品
    getReList() {
      const params = {
        pageIndex: 1,
        pageSize: 4,
        recommendFlag: 1,
        newsCode: this.params.newsCode,
      };
      sysNewsList(params).then((res) => {
        if (res.code === 0) {
          this.recommendList = res.data.list;
        }
      });
    },
    getRecent() {
      this.params.pageIndex = this.$route.query.num;
      // 获取最近新闻 api
      getRecentNews({ ...this.params, newsId: this.nowNew.id }).then((res) => {
        this.preNew = res.data.last == null ? {} : res.data.last;
        this.nextNew = res.data.next == null ? {} : res.data.next;
      });
    },
    changeNew(type) {
      // 区分左右按钮
      const query = {
        id: type == "pre" ? this.preNew.id : this.nextNew.id,
        num: type == "pre" ? this.preNew.pageIndex : this.nextNew.pageIndex,
        code: this.params.newsCode,
      };
      this.$router.replace("/productDetail?" + qs.stringify(query));
      this.$router.go(0);
    },
    getDetail(item) {
      const query = {
        id: item.id,
        num: this.$route.query.num,
        code: "25d8062b40214b4d86d6809fc31fa6fb",
      };
      this.$router.replace("/productDetail?" + qs.stringify(query));
      this.$router.go(0);
    },
  },
};
</script>

<style lang='scss' scoped>
@function pxToRem($args) {
  @return $args / 50 + rem;
}
.detail {
  width: 100%;

  .top {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: relative;
    &:hover button {
      display: block;
    }

    img {
      width: 500px;
      height: 500px;
      display: block;
    }
    .intro-box {
      width: 320px;
      max-height: 400px;
      background-color: #eee;
      border-top: 5px $theme solid;

      .intro-title {
        text-align: center;
        font-size: 22px;
        line-height: 80px;
      }
      .intro-desc {
        background-color: #f5f5f5;
      }
      .sub {
        padding: 30px 25px 0 25px;
        font-size: 14px;
        line-height: 20px;
        box-sizing: border-box;
      }
      .text {
        padding: 20px 25px;
        font-size: 14px;
        line-height: 24px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 10;
        -webkit-box-orient: vertical;
        overflow: hidden;
        box-sizing: border-box;
      }
    }

    button {
      width: 60px;
      height: 90px;
      color: #fff;
      border-radius: 10px;
      border: none;
      outline: none;
      font-weight: bold;
      font-size: 40px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background-color: rgba($color: #000000, $alpha: 0.2);
      display: none;

      &:hover {
        cursor: pointer;
      }
    }
    .pre {
      left: 0;
    }
    .next {
      right: 0;
    }
  }
  .bottom {
    margin-top: 40px;
    background: #f6f6f6;
  }
}
.content {
  width: 1200px;
  margin: 0 auto;

  &::before {
    content: "";
    display: table;
  }

  p {
    border-left: 5px $theme solid;
    font-size: 22px;
    padding-left: 20px;
    margin-top: 40px;
    line-height: 22px;
  }

  .con-desc,
  .recommed {
    padding: 25px;
    font-size: 14px;
    line-height: 28px;
    color: #666666;
  }
  .recommed {
    display: flex;
    text-align: center;
    margin-top: 20px;
    .re-item {
      width: 24%;
      margin-right: 10px;
      transition: all 0.3s;
      &:hover {
        cursor: pointer;

        .desc {
          color: $theme;
        }
      }

      img {
        width: 100%;
        height: 273px;
        display: block;
      }
      .desc {
        margin-bottom: 10px;
      }
    }
  }
}
@media (max-width: 1300px) {
  .detail {
    .top {
      width: 1000px;
    }
    .bottom .content {
      width: 1000px;
    }
  }
}
@media (max-width: 1024px) {
  .detail {
    padding: pxToRem(20);
    box-sizing: border-box;

    .m-title {
      font-size: pxToRem(20);
      line-height: pxToRem(50);
      margin-bottom: pxToRem(20);
      font-weight: bold;
      color: #cc0f16;
      text-align: center;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: pxToRem(40);
        height: 1px;
        background-color: $theme;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .m-img-box {
      .just {
        width: 100%;
      }
      .van-swipe {
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .content {
      width: 100%;

      p {
        font-size: pxToRem(16);
      }
      .con-desc {
        padding: pxToRem(25) 0;
      }
    }
    .other {
      font-size: 15px;
      margin-top: 20px;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      user-select: none;

      .symbol {
        display: none;
      }
      .pre,
      .next {
        padding: pxToRem(6) pxToRem(18);
        border-radius: pxToRem(5);
        border: 1px solid #6c757d;
        color: #6c757d;

        .symbol {
          display: inline-block;
        }
        .preview {
          display: none;
        }
        &:hover {
          border-color: $theme;
        }
      }
      .pre:hover,
      .next:hover {
        cursor: pointer;
        color: $theme;
      }
    }
  }
}
</style>
